import { React } from 'react';
import { Flex, Image, Text, Button } from '@chakra-ui/react';
import { signOut } from '../../services/authService';
import noInterviewsImage from '../../images/no-interviews.png';

// Shown when getByEmail returns 404: there's no active/current interviewer row for this account (deactivated in Zoho).
// Unlike a transient error, retrying won't help — so we give a clear explanation and a way out (sign out) instead of "Try again".
function InterviewerNotFound() {
  return (
    <Flex flexDirection='column' alignItems='center' maxWidth='715px' mx='auto' mt='100px' textAlign='center'>
      <Image src={noInterviewsImage} alt='No active screener profile' />
      <Text fontSize='20px' fontWeight='700' mt='40px' mb='16px'>
        We couldn&apos;t find an active screener profile for your account
      </Text>
      <Text fontSize='20px' color='gray.600'>
        Your interviewer profile isn&apos;t active right now. If you think this is a mistake, please reach out to the
        Nexton team.
      </Text>
      <Button mt='32px' colorScheme='blue' onClick={() => signOut()}>
        Sign out
      </Button>
    </Flex>
  );
}

export default InterviewerNotFound;
